(function () {
  'use strict';
  var root = document.querySelector('[data-color-guide]');
  if (!root) return;
  var track = function (event, detail) {
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event, source: 'color_guide' }, detail || {}));
  };
  var params = new URLSearchParams(location.search);
  var utms = new URLSearchParams();
  params.forEach(function (value, key) { if (key.indexOf('utm_') === 0) utms.set(key, value); });
  var colors = { amarelo: '#f0c92e', azul: '#29417c', branco: '#ffffff', cinza: '#8b8b86', preto: '#1d1d1d', roxo: '#68195a', verde: '#2e6331', vermelho: '#af2929' };
  var options = Array.from(root.querySelectorAll('[data-color-option]'));
  var visible = options.slice();
  var state = { base: 'all', secondary: 'all', ratio: 'all' };
  var filterOrder = [];
  var active = options.find(function (item) { return item.dataset.slug === params.get('combinacao'); }) || options[0];
  var image = root.querySelector('[data-reference-image]');
  var summary = root.querySelector('[data-selection-summary]');
  var gallery = root.querySelector('[data-combination-gallery]');
  var empty = root.querySelector('[data-empty-state]');
  var bar = root.querySelector('[data-reference-bar]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var name = root.querySelector('[data-reference-name]');
  var ratio = root.querySelector('[data-reference-ratio]');
  var referenceNavigation = root.querySelector('[data-reference-navigation]');
  var collectionNavigation = root.querySelector('[data-collection-navigation]');
  var result = root.querySelector('[data-filter-results]');
  var engaged = false;

  function proportion(item) {
    var values = item.dataset.ratio.split('/');
    return values[0] + '% ' + item.dataset.base + ' · ' + values[1] + '% ' + item.dataset.secondary;
  }
  function pageUrl(item) {
    var url = new URL(root.dataset.pageUrl);
    if (item) url.searchParams.set('combinacao', item.dataset.slug);
    utms.forEach(function (value, key) { url.searchParams.set(key, value); });
    return url.toString();
  }
  function whatsapp(message) { return root.dataset.whatsappBase + '?text=' + encodeURIComponent(message); }
  function selectionDescription() {
    return [state.base !== 'all' ? 'base ' + state.base : '', state.secondary !== 'all' ? 'complemento ' + state.secondary : '', state.ratio !== 'all' ? 'proporção ' + state.ratio : ''].filter(Boolean).join(', ');
  }
  function updateLinks() {
    var message = visible.length ?
      'Olá! Gostei da referência ' + active.dataset.name + ' (' + proportion(active) + ') e quero conversar sobre essa combinação. ' + pageUrl(active) :
      'Olá! Quero conversar sobre uma personalização de cores: ' + selectionDescription() + '. ' + pageUrl(null);
    root.querySelectorAll('[data-reference-whatsapp]').forEach(function (link) { link.href = whatsapp(message); });
    root.querySelector('[data-custom-whatsapp]').href = whatsapp('Olá! Quero conversar sobre uma personalização de cores: ' + selectionDescription() + '. ' + pageUrl(null));
    root.querySelectorAll('.rw-colors__reference-actions [data-reference-whatsapp]').forEach(function (link) {
      link.textContent = visible.length ? 'Conversar sobre esta referência ↗' : 'Conversar sobre personalização ↗';
    });
    root.querySelector('.rw-colors__sticky [data-reference-whatsapp]').textContent = visible.length ? 'Enviar referência' : 'Personalizar cores';
  }
  function engage() {
    if (engaged) return;
    engaged = true;
    root.classList.add('is-engaged');
    var sticky = root.querySelector('[data-mobile-sticky]');
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        var height = sticky.getBoundingClientRect().height;
        if (height) root.style.setProperty('--sticky-height', height + 'px');
      }).observe(sticky);
    }
  }
  function otherCards() { return visible.filter(function (item) { return item !== active; }); }
  function updateCollectionCount() {
    var cards = otherCards();
    var index = 0, distance = Infinity;
    cards.forEach(function (card, i) {
      var current = Math.abs(card.getBoundingClientRect().left - gallery.getBoundingClientRect().left);
      if (current < distance) { distance = current; index = i; }
    });
    root.querySelector('[data-collection-count]').textContent = cards.length ? (index + 1) + ' / ' + cards.length : '';
    root.querySelector('[data-collection-prev]').disabled = index === 0;
    root.querySelector('[data-collection-next]').disabled = index >= cards.length - 1;
    return index;
  }
  function render(updateUrl) {
    root.querySelectorAll('[data-filter-key]').forEach(function (button) {
      var key = button.dataset.filterKey, value = button.dataset.filterValue;
      var available = value === 'all' || options.some(function (item) {
        return item.dataset[key] === value && Object.keys(state).every(function (other) {
          return other === key || state[other] === 'all' || item.dataset[other] === state[other];
        });
      });
      button.hidden = !available;
      button.disabled = !available;
      button.setAttribute('aria-pressed', state[key] === value ? 'true' : 'false');
    });
    root.classList.toggle('is-empty', visible.length === 0);
    empty.hidden = visible.length !== 0;
    gallery.hidden = visible.length < 2;
    summary.hidden = visible.length === 0;
    referenceNavigation.hidden = visible.length < 2;
    collectionNavigation.hidden = visible.length < 3;
    options.forEach(function (item) {
      item.hidden = visible.indexOf(item) === -1 || item === active;
      item.setAttribute('aria-pressed', item === active ? 'true' : 'false');
    });
    result.textContent = visible.length === 1 ? '1 exemplo fotografado' : visible.length + ' exemplos fotografados';
    if (visible.length) {
      image.src = active.dataset.src;
      image.alt = 'Placa Rewave com ' + proportion(active);
      name.textContent = active.dataset.name;
      ratio.textContent = proportion(active);
      root.querySelector('[data-selection-name]').textContent = active.dataset.name;
      root.querySelector('[data-selection-ratio]').textContent = proportion(active);
      bar.style.setProperty('--share', active.dataset.ratio.split('/')[0] + '%');
      bar.style.setProperty('--base-color', colors[active.dataset.base]);
      bar.style.setProperty('--secondary-color', colors[active.dataset.secondary]);
      var index = visible.indexOf(active);
      root.querySelector('[data-reference-count]').textContent = (index + 1) + ' / ' + visible.length;
      root.querySelector('[data-reference-prev]').disabled = index <= 0;
      root.querySelector('[data-reference-next]').disabled = index >= visible.length - 1;
    }
    if (updateUrl) {
      var current = new URL(location.href);
      if (visible.length) current.searchParams.set('combinacao', active.dataset.slug);
      else current.searchParams.delete('combinacao');
      history.replaceState({}, '', current);
    }
    updateLinks();
    requestAnimationFrame(updateCollectionCount);
  }
  function view(item, returnToStage) {
    if (!item) return;
    active = item;
    render(true);
    engage();
    track('view_color_combination', { combination_name: item.dataset.name, ratio: item.dataset.ratio, base_color: item.dataset.base, secondary_color: item.dataset.secondary });
    if (returnToStage) {
      var target = root.querySelector('[data-reference-panel]');
      target.focus({ preventScroll: true });
      root.querySelector('[data-reference-panel]').scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    }
  }
  // Keep the latest choice, then retain older compatible choices in recency order.
  function resolveFilters(items, current, order, key, value) {
    var next = { base: 'all', secondary: 'all', ratio: 'all' };
    var priority = [key].concat(order.filter(function (name) { return name !== key; }));
    Object.keys(next).forEach(function (name) { if (priority.indexOf(name) === -1) priority.push(name); });
    var matches = items.slice(), cleared = [];
    priority.forEach(function (name) {
      var wanted = name === key ? value : current[name];
      if (wanted === 'all') return;
      var candidates = matches.filter(function (item) { return item.dataset[name] === wanted; });
      if (candidates.length) { next[name] = wanted; matches = candidates; }
      else cleared.push(name);
    });
    return { state: next, order: priority.filter(function (name) { return next[name] !== 'all'; }), matches: matches, cleared: cleared };
  }
  function filter(key, value) {
    var resolved = resolveFilters(options, state, filterOrder, key, value);
    state = resolved.state;
    filterOrder = resolved.order;
    visible = resolved.matches;
    var labels = { base: 'A cor base', secondary: 'A cor complementar', ratio: 'A proporção' };
    root.querySelector('[data-filter-feedback]').textContent = resolved.cleared.map(function (name) {
      return labels[name] + ' foi redefinida para mostrar exemplos com sua nova escolha.';
    }).join(' ');
    var changed = visible.length && visible.indexOf(active) === -1;
    if (changed) active = visible[0];
    render(true);
    engage();
    gallery.scrollLeft = 0;
    track('filter_color_combinations', { base_color: state.base, secondary_color: state.secondary, ratio: state.ratio, result_count: visible.length });
    if (changed) track('view_color_combination', { combination_name: active.dataset.name, ratio: active.dataset.ratio, base_color: active.dataset.base, secondary_color: active.dataset.secondary });
  }
  root.querySelectorAll('[data-filter-key]').forEach(function (button) {
    button.addEventListener('click', function () { filter(button.dataset.filterKey, button.dataset.filterValue); });
  });
  root.querySelector('[data-filter-reset]').addEventListener('click', function () {
    state = { base: 'all', secondary: 'all', ratio: 'all' };
    filterOrder = [];
    filter('base', 'all');
  });
  options.forEach(function (button) { button.addEventListener('click', function () { view(button, true); }); });
  function step(delta) { view(visible[visible.indexOf(active) + delta], false); }
  root.querySelector('[data-reference-prev]').addEventListener('click', function () { step(-1); });
  root.querySelector('[data-reference-next]').addEventListener('click', function () { step(1); });
  var panel = root.querySelector('[data-reference-panel]');
  panel.setAttribute('tabindex', '0');
  panel.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  var touchStart;
  panel.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'touch') touchStart = { x: event.clientX, y: event.clientY };
  }, { passive: true });
  panel.addEventListener('pointerup', function (event) {
    if (!touchStart) return;
    var x = event.clientX - touchStart.x, y = event.clientY - touchStart.y;
    touchStart = null;
    if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.5) step(x < 0 ? 1 : -1);
  }, { passive: true });
  panel.addEventListener('pointercancel', function () { touchStart = null; });

  function collectionStep(delta) {
    var cards = otherCards(), index = updateCollectionCount();
    var next = cards[Math.max(0, Math.min(cards.length - 1, index + delta))];
    if (next) gallery.scrollTo({ left: next.offsetLeft - gallery.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
  }
  root.querySelector('[data-collection-prev]').addEventListener('click', function () { collectionStep(-1); });
  root.querySelector('[data-collection-next]').addEventListener('click', function () { collectionStep(1); });
  gallery.addEventListener('scroll', updateCollectionCount, { passive: true });
  root.querySelectorAll('[data-sample-kit]').forEach(function (link) {
    var url = new URL(root.dataset.kitUrl, location.origin);
    utms.forEach(function (value, key) { url.searchParams.set(key, value); });
    link.href = url.toString();
    link.addEventListener('click', function () { track('click_sample_kit'); });
  });
  root.querySelectorAll('[data-availability-whatsapp]').forEach(function (link) {
    link.href = whatsapp('Olá! Quero consultar as cores disponíveis. ' + pageUrl(null));
    link.addEventListener('click', function () {
      track('click_color_whatsapp', { intent: 'consultar_cores_disponiveis', source_area: 'abertura_educativa' });
    });
  });
  root.querySelectorAll('[data-reference-whatsapp], [data-custom-whatsapp]').forEach(function (link) {
    link.addEventListener('click', function () {
      track('click_color_whatsapp', { combination_name: visible.length ? active.dataset.name : 'personalizacao', ratio: visible.length ? active.dataset.ratio : state.ratio, base_color: state.base, secondary_color: state.secondary });
    });
  });
  root.querySelectorAll('.rw-colors__faq details').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) track('view_color_faq', { question: item.querySelector('summary').textContent.trim() });
    });
  });
  var editorial = root.querySelector('[data-editorial-gallery]');
  var slides = Array.from(root.querySelectorAll('[data-editorial-slide]'));
  function editorialIndex() {
    var index = 0, distance = Infinity;
    slides.forEach(function (slide, i) {
      var delta = Math.abs(slide.getBoundingClientRect().left - editorial.getBoundingClientRect().left - 32);
      if (delta < distance) { distance = delta; index = i; }
    });
    return index;
  }
  function editorialStep(delta) {
    var index = Math.max(0, Math.min(slides.length - 1, editorialIndex() + delta));
    editorial.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
  }
  root.querySelector('[data-gallery-prev]').addEventListener('click', function () { editorialStep(-1); });
  root.querySelector('[data-gallery-next]').addEventListener('click', function () { editorialStep(1); });
  editorial.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); editorialStep(event.key === 'ArrowRight' ? 1 : -1); }
  });
  editorial.addEventListener('scroll', function () { root.querySelector('[data-gallery-status]').textContent = (editorialIndex() + 1) + ' / 5'; }, { passive: true });
  var drag;
  editorial.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse') return;
    event.preventDefault();
    drag = { x: event.clientX, scroll: editorial.scrollLeft };
    editorial.setPointerCapture(event.pointerId);
  });
  editorial.addEventListener('pointermove', function (event) { if (drag) editorial.scrollLeft = drag.scroll - (event.clientX - drag.x); });
  function stopDrag() { drag = null; }
  editorial.addEventListener('pointerup', stopDrag);
  editorial.addEventListener('pointercancel', stopDrag);
  editorial.addEventListener('lostpointercapture', stopDrag);

  var productCase = root.querySelector('[data-product-case]');
  if (productCase) {
    var productStage = productCase.querySelector('[data-product-stage]');
    var productPhotos = Array.from(productCase.querySelectorAll('[data-product-photo]'));
    var productButtons = Array.from(productCase.querySelectorAll('[data-product-view]'));
    var productView = 0;
    function showProductView(index, userInitiated) {
      var next = Math.max(0, Math.min(productPhotos.length - 1, index));
      var changed = next !== productView;
      productView = next;
      productPhotos.forEach(function (photo, i) { photo.hidden = i !== productView; });
      productButtons.forEach(function (button, i) { button.setAttribute('aria-pressed', String(i === productView)); });
      productCase.querySelector('[data-product-status]').textContent = productPhotos[productView].dataset.productLabel + ', ' + (productView + 1) + ' de ' + productPhotos.length;
      if (changed && userInitiated) track('switch_color_product_view', { product_name: 'Carrinho OBJ', photo_view: productPhotos[productView].dataset.productKind });
    }
    productPhotos.forEach(function (photo) {
      var photoImage = photo.querySelector('img');
      function photoFailed() {
        photo.classList.add('is-unavailable');
        photo.querySelector('[data-product-fallback]').hidden = false;
      }
      photoImage.addEventListener('error', photoFailed);
      if (photoImage.complete && !photoImage.naturalWidth) photoFailed();
    });
    productButtons.forEach(function (button, i) {
      button.addEventListener('click', function () { showProductView(i, true); });
      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        showProductView(event.key === 'ArrowRight' ? 1 : 0, true);
        productButtons[productView].focus();
      });
    });
    productStage.setAttribute('tabindex', '0');
    productStage.setAttribute('role', 'group');
    productStage.setAttribute('aria-label', 'Fotos do carrinho OBJ. Use as setas para alternar produto completo e detalhe da matéria.');
    productStage.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showProductView(event.key === 'ArrowRight' ? 1 : 0, true);
    });
    var productTouch;
    productStage.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') productTouch = { x: event.clientX, y: event.clientY };
    }, { passive: true });
    productStage.addEventListener('pointerup', function (event) {
      if (!productTouch) return;
      var dx = event.clientX - productTouch.x, dy = event.clientY - productTouch.y;
      productTouch = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) showProductView(dx < 0 ? 1 : 0, true);
    }, { passive: true });
    productStage.addEventListener('pointercancel', function () { productTouch = null; });
    productCase.querySelector('[data-product-view-controls]').hidden = false;
    showProductView(0, false);

    root.querySelectorAll('[data-product-anchor], [data-guide-anchor]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (link.dataset.productAnchor) track('click_color_product_navigation', { direction: link.dataset.productAnchor, product_name: 'Carrinho OBJ', source_area: link.dataset.navigationSource || 'product_case' });
        if (event.detail === 0) {
          var target = root.querySelector(link.getAttribute('href'));
          if (target) window.setTimeout(function () {
            target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
          }, 0);
        }
      });
    });
    var productViewed = false;
    function productVisible(isVisible, enoughVisible) {
      root.classList.toggle('is-product-visible', isVisible);
      if (enoughVisible && !productViewed) {
        productViewed = true;
        track('view_color_product_case', { product_name: 'Carrinho OBJ', photo_view: productPhotos[productView].dataset.productKind });
      }
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { productVisible(entry.isIntersecting, entry.intersectionRatio >= .25); });
      }, { threshold: [0, .25], rootMargin: '-100px 0px 0px 0px' }).observe(productCase);
    } else {
      var productFramePending = false;
      function checkProductVisibility() {
        if (productFramePending) return;
        productFramePending = true;
        requestAnimationFrame(function () {
          var rect = productCase.getBoundingClientRect();
          var overlap = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 100));
          productVisible(overlap > 0, overlap >= Math.min(rect.height, window.innerHeight) * .25);
          productFramePending = false;
        });
      }
      window.addEventListener('scroll', checkProductVisibility, { passive: true });
      window.addEventListener('resize', checkProductVisibility, { passive: true });
      checkProductVisibility();
    }
  }
  root.querySelector('[data-visual-filters]').hidden = false;
  render(false);
  track('view_color_guide', { page_path: '/pages/cores' });
})();
